export default __webpack_public_path__ + "static/media/bca.e7e35271.png";